import React, { Component } from 'react';

import KuposPlacesInput from './KuposPlacesInput';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

class KuposTextArea extends Component {
  static propTypes = {
    placeholder: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    className: PropTypes.string,
    iconRight: PropTypes.string,
    icon: PropTypes.string,
    iconRightClick: PropTypes.func,
    onSideClick: PropTypes.func,
    disabled: PropTypes.bool,
    type: PropTypes.string,
    style: PropTypes.object,
    inputWidth: PropTypes.object,
    focused: PropTypes.object,
    showPasswordIcon: PropTypes.bool,
    password: PropTypes.bool,
    fontSize: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      focused: this.props.focused,
      isPassowrd: this.props.password,
    };
  }

  componentDidMount() {}

  onFocusChange = event => {
    if (this.props.onFocus) {
      this.props.onFocus(event);
    }

    this.props.focused ? this.setState({ focused: false }) : null;
  };

  render() {
    // console.log("FontSize", this.props.fontSize)
    return (
      <div className="common-kupos-textarea" style={this.props.style}>
        {this.props.label && <div className="input-label font10 bold-text">{this.props.label}</div>}
        <div
          className={
            'flex-row textarea-outer ' + this.props.className + (this.props.error ? ' error' : '')
          }
          style={this.props.inputOuterStyle}
        >
          <textarea
            pattern={this.props.pattern == 'chars' ? '[A-Za-z]' : null}
            className={this.props.fontSize ? this.props.fontSize : 'font11'}
            placeholder={
              this.props.t ? this.props.t(this.props.placeholder) : this.props.placeholder
            }
            onFocus={event => this.onFocusChange(event.target)}
            value={this.props.value}
            style={
              ([this.props.inputWidth, this.props.height],
              this.props.disabled ? { color: '#919191' } : {})
            }
            onChange={this.props.onChange ? event => this.props.onChange(event.target.value) : null}
            // onChange={event => {
            //   console.log('onChange', event.target.value);
            //   console.log('onChange', this.props.onChange);

            //   this.props.onChange ? event => this.props.onChange(event.target.value) : null;
            // }}
            onBlur={this.props.onBlur ? event => this.props.onBlur(event.target.value) : null}
            disabled={this.props.disabled}
            readOnly={this.props.readOnly}
            rows="6"
          />
        </div>
        {this.props.error ? (
          <span className="error font9">{this.props.t(this.props.errorMessage)}</span>
        ) : null}
      </div>
    );
  }
}

export default withTranslation('common')(KuposTextArea);



// WEBPACK FOOTER //
// ./src/features/common/KuposTextArea.js